export default function isExternalURL(url: string) {
  try {
    const targetUrl = new URL(url, window.location.href)
    return targetUrl.origin !== window.location.origin
  } catch (_e) {
    return false
  }
}
